import { Component } from '@angular/core';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { vmProductosService } from 'src/app/view-model/services/productos.service';
import { BaseProductComponent } from '../base-product/base-product.component';

@Component({
  selector: 'app-link-pago-product',
  templateUrl: './link-pago-product.component.html',
  styleUrls: ['./link-pago-product.component.scss']
})
export class LinkPagoProductComponent extends BaseProductComponent  {

  constructor(
    protected carroComprasService: CarroComprasService,
    protected marketplaceRedirectService: MarketplaceRedirectService,
    protected dialogService: DialogService,
    protected storageServ: LocalStorageService,
    protected tagM: TagManagerService,
    protected productoServiceVM: vmProductosService,
    protected localStorageService: LocalStorageService
    ) {
    super(carroComprasService,
      marketplaceRedirectService,
      dialogService,
      storageServ,
      tagM,
      productoServiceVM,
      localStorageService);
   }

}
